import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromMultishareHistory from './multishare-history.reducer';

export const selectMultishareHistoryState = createFeatureSelector<fromMultishareHistory.State>(
  fromMultishareHistory.multishareHistoryFeatureKey
);
export const selectMultishareHistoryEntries = createSelector(selectMultishareHistoryState, s1 => s1.histories);
